import React, { useContext, useMemo } from 'react'
import { Link, Outlet } from 'react-router';
import AuthContext, { AuthState } from '../../contexts/AuthContext';
import useDeviceSize, { DeviceSize } from '../../hooks/useDeviceSize';
import BigLoader from '../table/BigLoader';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@mui/icons-material/Error';
import { paymentsPage } from '../../config/routeConfig';
import MobileHeader from '../header/MobileHeader';
import SideHeader from '../header/SideHeader';

type Props = {
    children?: React.ReactNode;
}

const HeaderLayout = ({ children }: Props) => {
    const { authState, userInfo } = useContext(AuthContext);
    const device = useDeviceSize();
    const { t } = useTranslation();
    const showInvoiceAlert = useMemo(() => {
        if (userInfo?.selected_restaurant?.outstanding_invoice === undefined) {
            return false;
        }
        return userInfo?.selected_restaurant?.outstanding_invoice >= 2;
    }, [userInfo?.selected_restaurant?.outstanding_invoice]);

    if (authState !== AuthState.LOGGED_IN) {
        return <BigLoader />
    }

    if (device === DeviceSize.Mobile) {
        return (
            <div>
                <MobileHeader />
                <Outlet />
            </div>
        )
    }

    return (
        <div className="flex">
            <SideHeader />
            {/* Content */}
            <div className="flex-1 h-screen overflow-auto" id="main-content">
                {showInvoiceAlert && (
                    <div className="flex bg-error text-white px-4 py-2 gap-3">
                        <ErrorIcon
                            style={{ fontSize: "44px" }}
                        />
                        <div>
                            <h1 className='text-[22px] font-bold'>
                                {t("common.warning")}
                            </h1>
                            <div className="text-[16px]">
                                {t("error.outstanding_invoice_alert", { count: userInfo?.selected_restaurant?.outstanding_invoice })}
                            </div>
                            <div className="py-4">
                                <Link to={paymentsPage.path} className="px-4 py-2 bg-white rounded-[8px] text-error font-semibold hover:bg-neutral-light">
                                    {t("common.view_invoices")}
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
                <Outlet />
            </div>
        </div>
    )
}

export default HeaderLayout